<script lang="ts">
    export let title : string = ''
    export let duration : string = ''
    export let percentage : string | number = 0
    export let className : string = ''
    export let highlight : boolean = false
</script>

<div class="experience-progress {className}">
    <div class="experience-progress__content">
        <div class="experience-progress__title">{title}</div>
        <div class="experience-progress__duration">{duration}</div>
    </div>
    <div class="experience-progress__bar" class:experience-progress__bar--highlight={highlight}>
        <div class="experience-progress__bar__percentage" class:experience-progress__bar__percentage--highlight={highlight} style:width={percentage}></div>
    </div>
</div>

<style lang="postcss">
    .experience-progress {
        display: grid;
        row-gap: 6px;
        width:100%;
        grid-template-areas:
            "A"
            "B";

        & .experience-progress__content {
            display: flex;
            justify-content: space-between;
        }

        & .experience-progress__bar {
            width:100%;
            background-color: #f3f4f5;
            display: block;
            height:8px;
            border-radius: 8px;
            overflow: hidden;

            & .experience-progress__bar__percentage {
                display: block;
                height:100%;
                background-color: var(--color_grey_secondary);
                transition:width 1s;
                border-radius: 8px;
            }
        }

        & .experience-progress__bar--highlight {
            background: rgb(228, 240, 252);

            & .experience-progress__bar__percentage--highlight {
                background: rgb(94, 165, 238);
            }
        }
    }
</style>